import { InvoiceID, InvoiceInfo } from "@imago/model"
import { useCare } from './user-care.ts'
import { Zoned } from './_zoned.ts'

const oldInvoices = new Map<InvoiceID, Zoned<InvoiceInfo>>()

export function useInvoice(ID: InvoiceID | undefined): Zoned<InvoiceInfo> | undefined {
	if (ID === undefined) return
	const care = useCare()
	if (care === undefined) return
	const {unpaidInvoices} = care
	const invoice = unpaidInvoices.filter(i => i.ID === ID)[0]
	if (!invoice) {
		const oldInvoice = oldInvoices.get(ID)
		if (!oldInvoice) throw new Error('Invalid invoice ID')
		oldInvoice.amountRemaining = 0
		return oldInvoice
	}
	oldInvoices.set(invoice.ID, invoice)
	return invoice
}
